import React, { useMemo } from 'react';
import { SmartQuestionRenderer } from 'components/stepper/field-components/QuestionnaireField';
import { GetQuestionnaireOutput } from 'graphql/generated/remote-schema-hasura';
import { useQuestionnaireSections } from 'components/questionnaire/hooks/useQuestionnaire';
import { DynamicQuestionnaireDependencie } from 'components/dynamicQuestionnaire/interfaces/dynamicQuestionnaireResponse.interface';
import { useGetDynamicDeps } from 'components/stepper/useStepperForm';
import BloodPressureField from './BloodPressureField';
import {
  AllergensQuestionnaireField,
  MedAllergensQuestionnaireField,
} from './AllergenField';
import {
  ADDITIONAL_INFORMATION_ID,
  ALLERGENS_ID,
  BLOOD_PRESSURE_ID,
  MED_ALLERGENS_ID,
} from '../useQuestionaireValidations';
import AdditionalInformation from './AdditionalInformation';

interface QuestionnaireSectionProps {
  getQuestionnaireOutput: GetQuestionnaireOutput;
  sectionIndex: number;
}

const QuestionnaireSection: React.FC<QuestionnaireSectionProps> = ({
  getQuestionnaireOutput,
  sectionIndex,
}) => {
  const { questionList, currentSection, questionsById } =
    useQuestionnaireSections(getQuestionnaireOutput, sectionIndex);

  const testDependencies = useMemo(
    () => [
      ...(currentSection?.dependencies || []),
      {
        __typename: 'DynamicQuestionnaireDependencies',
        if: {
          properties: {
            '85': {
              const: 'Yes',
            },
          },
        },
        then: {
          __typename: 'ThenObject',
          enabled: ['850'],
          required: null,
        },
      } as unknown as DynamicQuestionnaireDependencie,
    ],
    [currentSection?.dependencies],
  );

  const dynamicDeps = useGetDynamicDeps(testDependencies);

  return (
    <div className="w-full flex justify-center mt-[30px]">
      <div className="flex flex-col max-w-[570px] gap-[30px]">
        <SmartQuestionRenderer
          questionList={questionList}
          dependencies={testDependencies}
          questionsById={questionsById}
          dynamicDeps={dynamicDeps}
          customFields={{
            [BLOOD_PRESSURE_ID]: BloodPressureField,
            [ALLERGENS_ID]: AllergensQuestionnaireField,
            [MED_ALLERGENS_ID]: MedAllergensQuestionnaireField,
            [ADDITIONAL_INFORMATION_ID]: AdditionalInformation,
          }}
        />
      </div>
    </div>
  );
};

export default QuestionnaireSection;
